export default __webpack_public_path__ + "static/my-mg-logo-white-0cf5d0bd54bb0831db93c3bfc383bb5d.svg";